import React, { useEffect } from "react";
import { Box, TextField } from "@mui/material";
import CustomSwitch from "./CustomSwitch";

const SwitchWithInput = ({ value, onChange, inputValue, onInputChange }) => {
  useEffect(() => {
    if (value === null || value === undefined) {
      onChange("No");
    }
  }, [onChange, value]);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <CustomSwitch
        options={["Yes", "No"]}
        value={value || "No"}
        onChange={onChange}
      />
      {value === "Yes" && (
        <TextField
          value={inputValue}
          onChange={(e) => onInputChange(e.target.value)}
          variant="outlined"
          size="small"
          type="number"
          InputProps={{
            endAdornment: "%",
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              clipPath: `polygon(
                91.274% 99.701%, 91.274% 99.701%, 90.749% 99.697%, 89.242% 99.684%, 86.852% 99.665%,
                83.68% 99.639%, 79.827% 99.608%, 75.394% 99.572%, 70.481% 99.532%, 65.189% 99.489%,
                59.618% 99.444%, 53.869% 99.397%, 53.869% 99.397%, 45.715% 98.905%, 38.211% 98.886%,
                31.366% 99.149%, 25.19% 99.503%, 19.691% 99.757%, 14.88% 99.718%, 10.767% 99.196%,
                7.36% 97.999%, 4.669% 95.936%, 2.704% 92.816%, 2.704% 92.816%, 1.61% 88.673%,
                0.885% 84.915%, 0.464% 81.338%, 0.285% 77.737%, 0.283% 73.907%, 0.393% 69.645%,
                0.551% 64.744%, 0.694% 59.002%, 0.758% 52.212%, 0.677% 44.171%, 0.677% 44.171%,
                0.585% 36.318%, 0.633% 29.185%, 0.845% 22.789%, 1.248% 17.148%, 1.864% 12.279%,
                2.72% 8.2%, 3.84% 4.927%, 5.249% 2.478%, 6.971% 0.87%, 9.031% 0.12%, 9.031% 0.12%,
                10.869% 0.135%, 14.925% 0.168%, 20.8% 0.215%, 28.094% 0.275%, 36.41% 0.342%,
                45.348% 0.415%, 54.509% 0.489%, 63.495% 0.562%, 71.905% 0.63%, 79.342% 0.691%,
                79.342% 0.691%, 82.762% 0.765%, 86.028% 0.605%, 89.083% 0.56%, 91.869% 0.978%,
                94.328% 2.209%, 96.403% 4.602%, 98.036% 8.506%, 99.17% 14.27%, 99.747% 22.243%,
                99.71% 32.774%, 99.71% 32.774%, 99.559% 43.742%, 99.565% 53.889%, 99.612% 63.165%,
                99.584% 71.524%, 99.362% 78.917%, 98.831% 85.295%, 97.873% 90.611%, 96.373% 94.816%,
                94.212% 97.862%, 91.274% 99.701%
              )`,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              border: "none",
            },
          }}
        />
      )}
    </Box>
  );
};

export default SwitchWithInput;
